import {ref} from 'vue'
import {useAxiosCreate} from '@/backend/utils.js'
import authHeader from '@/backend/auth/auth-header';

class ApiConnector{

	constructor() {
    	this.api = useAxiosCreate('admin');
  	}
	

	put({model,form}){
		const response = ref()
		const request = async ()=>{
			const res = await this.api.put(model,form,{headers: authHeader()})
			response.value = res.data
		}
		return {response,request}
	}

	get({model,params}){
		const response = ref()
		const request = async ()=>{
			const res = await this.api.get(model,params,{headers: authHeader()})
			response.value = res.data
		}
		return {response,request}
	}

	updateBlackList(file){
		const formData = new FormData();
    	formData.append('file', file);

		const response = ref()
		const request = async ()=>{
			const res = await this.api.post('clientblacklist',formData,{
				 headers: {
					'Content-Type': 'multipart/form-data',
				},
			})
			response.value = res.data
		}
		return {response,request}
	}


}


export default ApiConnector